import { ArrowLeft } from '@griply/assets';
import React, { Suspense } from 'react';
import {
  Densities,
  TopBarBase,
} from 'shared/components/connected/top-bar-base';
import { IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useBackFunction } from 'shared/contexts/history';
import { Paths } from 'shared/routes/paths';

import { useIsProjectRoute } from '../../use-is-project-route';
import { GoalDetailBreadcrumbs } from '../goal-detail-breadcrumbs';
import { Interactions, LoadingInteractions } from './interactions';
import { NavigationTabs } from './navigation-tabs';
import * as Styled from './page-top-bar.style';
import { LoadingTitle } from './title';

export const PageTopBar: React.FC = () => {
  const isProjectRoute = useIsProjectRoute();
  const backFunction = useBackFunction(
    isProjectRoute ? Paths.Projects : Paths.Goals,
  );

  return (
    <Styled.Container>
      <TopBarBase
        hideBorder
        density={Densities.Compact}
        mobileNavigationSlot={<NavigationTabs />}
      >
        <Styled.Content>
          <Styled.LeadingContainer>
            <IconButton
              icon={ArrowLeft}
              onClick={backFunction}
              size={Sizes.Small}
              strokeWidth={2}
              preventDrag
            />
            <Styled.Divider />
            <Suspense fallback={<LoadingTitle />}>
              <GoalDetailBreadcrumbs />
            </Suspense>
          </Styled.LeadingContainer>

          <Styled.NavigationContainer>
            <NavigationTabs />
          </Styled.NavigationContainer>

          <Styled.InteractionsContainer>
            <Suspense fallback={<LoadingInteractions />}>
              <Interactions />
            </Suspense>
          </Styled.InteractionsContainer>
        </Styled.Content>
      </TopBarBase>
    </Styled.Container>
  );
};
